module.exports = __webpack_public_path__ + "img/upgrade-667b996b.1482aef7.png";